require('../../../assets/scripts/jhire/controllers/requisitions/jv.ReqsPixelCandidate.app.js');